/**
 * 
 */
class AnimateManager {

	/**
	 * @type Array
	 */
	animateList = [];

	/**
	 * @type Object
	 */
	animateSettings = null;

	/**
	 * @type HTMLElement
	 */
	contextElement = document;

	/**
	 * @type ScrollTrigger
	 */
	scrollTrigger = null;

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onViewportChange = this.onViewportChange.bind( this );
		document.addEventListener( 'WMUViewportChange', this.onViewportChange );

		this.scrollTrigger = new ScrollTrigger.default( {
			trigger: {
				offset: {},
				toggle: {
					class: {
						in: 'scroll-visible',
						out: 'scroll-invisible',
					},
				},
			},
			scroll: {
				sustain: 0,
			}
		} );

		this.animeSettings = wmuwpb && wmuwpb.animate 
			? wmuwpb.animate
			: {
			'fade': {
				opacity: {
					value: [0, 1],
					duration: 500,
					easing: 'easeInOutQuad',
				},
				delay: 0,
			},
			'translate-x': {
				translateX: {
					value: [-400, 0],
					duration: 500,
				},
				opacity: {
					value: [0, 1],
					duration: 500,
					easing: 'easeInOutQuad',
				},
				delay: 0,
			}
		};
	}

	/**
	 * 
	 * @param {String} viewport 
	 */
	setup( viewport )
	{
		const targetAttribute = `${viewport.toLowerCase()}-anime-type`;

		this.contextElement.querySelectorAll( `[${targetAttribute}]` ).forEach( ( element ) =>
		{
			const animeType = element.getAttribute( targetAttribute );
			const animeSetting = this.animeSettings[ animeType ] ? this.animeSettings[ animeType ] : false;

			if ( ! animeSetting ) return;
			
			this.scrollTrigger.add( element, {
				toggle: {
					callback: {
						in: ( trigger ) => {
							anime( {
								targets: trigger.element,
								...animeSetting
							} );
						},
					}
				}
			} );

			this.animateList.push( element );
		} );
	}

	/**
	 * 
	 * @param {String} viewport 
	 */
	clear( viewport )
	{
		const visibleClass = this.scrollTrigger.defaultTrigger.toggle.class.in;
		const invisibleClass = this.scrollTrigger.defaultTrigger.toggle.class.out;

		this.scrollTrigger.kill();

		this.animateList.forEach( ( element ) =>
		{
			element.classList.remove( visibleClass, invisibleClass );
		} );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onViewportChange( event )
	{
		if ( event.detail.previousViewport )
		{
			this.clear( event.detail.previousViewport );
		}
		
		this.setup( event.detail.currentViewport );
		this.scrollTrigger.listen();
	}

}

export default AnimateManager;